import { TableCell, Typography } from "@mui/material";

import { FormatTimeIn12HourFormat } from "../../../../../global/FormatISODateTime";
import CustomIconButton from "../../../../../ui library/components/buttons/CustomIconButton";
import Svg, { SvgEnum } from "../../../../../ui library/components/svgs/standard/svg";
import HNSColors from "../../../../../ui library/HNSColors";

export default function ProviderHoursViewCell({ row, index, onEdit }) {
  return (
    <>
      <TableCell>{row.day}</TableCell>

      <TableCell>
        {row.timings.length ? (
          row.timings.map((t, i) => (
            <Typography key={i}>
              {`${FormatTimeIn12HourFormat(t.startTime)} to ${FormatTimeIn12HourFormat(
                t.endTime
              )}`}
            </Typography>
          ))
        ) : (
          <div
            className="w-fit min-w-28 p-2"
            style={{
              borderRadius: "500px",
              backgroundColor: HNSColors.failure[700],
            }}
          >
            <Typography
              className="text-center text-[14px]"
              color={HNSColors.neutrals[100]}
            >
              Closed
            </Typography>
          </div>
        )}
      </TableCell>

      <TableCell>
        <CustomIconButton
          iconVisible
          CustomIcon={
            <Svg
              name={SvgEnum.HisEdit3}
              color={HNSColors.primary[500]}
              onClick={() => onEdit(index, row.timings)}
            />
          }
        />
      </TableCell>
    </>
  );
}
